import { EXTERNAL_SYNC_PROVIDERS } from 'shared/constants/external-sync.constants';

/**
 * Sent with every My Content request — the provider owns synced items, so they never
 * appear on this page. Deliberately a frozen literal list, not Object.values(...): the
 * backend validates against its own enum and 400s on unknown values, so a new provider
 * must land there before it is added here.
 */
export const EXCLUDED_SYNC_PROVIDERS = [
  EXTERNAL_SYNC_PROVIDERS.SHAREPOINT,
  EXTERNAL_SYNC_PROVIDERS.POLICYTECH,
];

export const EXPIRY_STATUS = {
  EXPIRED: 'expired',
  ABOUT_TO_EXPIRE: 'about_to_expire',
  EXPIRES_IN_3_MONTHS: 'expires_in_3_months',
};

export const DEFAULT_SORT_DEFINITIONS = {
  sortBy: '', // No default sort - only set on initial load
  sortOrder: 'asc',
  pageSize: 25,
  // Initial sort to apply on first page load only
  initialSortBy: 'expiresAt',
  initialSortOrder: 'asc',
};
